import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { getTenantBranding } from '../../api/examApi';

const IconGrid = () => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <rect x="2" y="2" width="6" height="6" rx="1.5"/>
    <rect x="10" y="2" width="6" height="6" rx="1.5"/>
    <rect x="2" y="10" width="6" height="6" rx="1.5"/>
    <rect x="10" y="10" width="6" height="6" rx="1.5"/>
  </svg>
);

const IconFolder = () => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <path d="M2 5a2 2 0 012-2h3l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V5z"/>
  </svg>
);

const IconDatabase = () => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <ellipse cx="9" cy="5" rx="6" ry="2.5"/>
    <path d="M3 5v4c0 1.38 2.69 2.5 6 2.5S15 10.38 15 9V5"/>
    <path d="M3 9v4c0 1.38 2.69 2.5 6 2.5S15 14.38 15 13V9"/>
  </svg>
);

const IconClipboard = () => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <rect x="4" y="3" width="10" height="13" rx="1.5"/>
    <path d="M6 3V2h6v1"/>
    <line x1="6" y1="8" x2="12" y2="8"/>
    <line x1="6" y1="11" x2="10" y2="11"/>
  </svg>
);

const IconChart = () => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <polyline points="2,14 6,9 10,12 16,4"/>
    <line x1="2" y1="14" x2="16" y2="14"/>
  </svg>
);

const IconUsers = () => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <circle cx="6.5" cy="6" r="2.5"/>
    <path d="M1 16c0-3 2.5-5 5.5-5"/>
    <circle cx="12.5" cy="6" r="2.5"/>
    <path d="M12.5 11c3 0 5.5 2 5.5 5"/>
  </svg>
);

const IconSettings = () => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <circle cx="9" cy="9" r="2.5"/>
    <path d="M9 1v2m0 12v2M1 9h2m12 0h2m-2.5-5.5-1.4 1.4M4.9 13.1l-1.4 1.4M15.5 13.5l-1.4-1.4M4.9 4.9 3.5 3.5"/>
  </svg>
);

const IconChevron = ({ direction = 'left' }) => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"
    style={{ transform: direction === 'right' ? 'rotate(180deg)' : 'none' }}>
    <polyline points="11,4 6,9 11,14"/>
  </svg>
);

const IconLogout = () => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
    <path d="M7 3H4a1 1 0 00-1 1v10a1 1 0 001 1h3"/>
    <polyline points="12,12 16,9 12,6"/>
    <line x1="16" y1="9" x2="7" y2="9"/>
  </svg>
);

const NAV_ITEMS = [
  { id: 'dashboard',     label: 'Dashboard',     Icon: IconGrid,      path: 'dashboard' },
  { id: 'projects',      label: 'Projects',       Icon: IconFolder,    path: 'projects' },
  { id: 'question-bank', label: 'Question Bank',  Icon: IconDatabase,  path: 'question-bank' },
  { id: 'evaluations',   label: 'Evaluations',    Icon: IconClipboard, path: 'evaluations' },
  { id: 'analytics',     label: 'Analytics',      Icon: IconChart,     path: 'analytics' },
  { id: 'faculty',       label: 'Faculty View',   Icon: IconUsers,     path: 'faculty' },
];

export default function ExamSidebar({ collapsed, onToggle, user }) {
  const navigate = useNavigate();
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    getTenantBranding().then(data => {
      if (data?.name || data?.logo) setBranding(data);
    });
  }, []);

  const initials = user
    ? `${(user.first_name || user.email || 'U')[0]}`.toUpperCase()
    : 'U';

  const handleLogout = () => {
    localStorage.removeItem('examToken');
    localStorage.removeItem('token');
    navigate('/examination/login');
  };

  return (
    <aside className={`exam-sidebar${collapsed ? ' collapsed' : ''}`}>
      {/* Logo / Branding */}
      <div className="exam-sidebar-logo" style={{ userSelect: 'none', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {branding?.logo ? (
            <img
              src={branding.logo}
              alt={branding.name || 'Logo'}
              style={{ height: 28, width: 28, objectFit: 'contain', borderRadius: 4, flexShrink: 0 }}
              onError={e => { e.target.style.display = 'none'; }}
            />
          ) : (
            <div className="exam-sidebar-logo-icon">
              <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <rect x="9" y="3" width="6" height="4" rx="1" stroke="white" strokeWidth="2"/>
                <path d="M9 12h6M9 16h4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
          )}
          {!collapsed && (
            <span className="exam-sidebar-logo-text">
              <span>Examination</span>OS
            </span>
          )}
        </div>
        {!collapsed && branding?.name && (
          <div style={{
            fontSize: 10, color: 'var(--exam-shell-text)', fontWeight: 500,
            marginTop: 2, paddingLeft: 2, lineHeight: 1.3,
            maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>
            {branding.name}
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="exam-nav">
        <div className="exam-nav-section">
          {!collapsed && <div className="exam-nav-label">Menu</div>}
          {NAV_ITEMS.map(({ id, label, Icon, path }) => (
            <NavLink
              key={id}
              to={`/examination/${path}`}
              className={({ isActive }) =>
                `exam-nav-item${isActive ? ' active' : ''}`
              }
              title={collapsed ? label : undefined}
            >
              <Icon className="exam-nav-item-icon" />
              {!collapsed && label}
            </NavLink>
          ))}
        </div>

        <div className="exam-nav-section" style={{ marginTop: 8 }}>
          {!collapsed && <div className="exam-nav-label">System</div>}
          <NavLink
            to="/examination/settings"
            className={({ isActive }) =>
              `exam-nav-item${isActive ? ' active' : ''}`
            }
            title={collapsed ? 'Settings' : undefined}
          >
            <IconSettings className="exam-nav-item-icon" />
            {!collapsed && 'Settings'}
          </NavLink>
        </div>
      </nav>

      {/* Footer */}
      <div className="exam-sidebar-footer">
        <div className="exam-user-pill" onClick={handleLogout} title="Sign out">
          <div className="exam-avatar">{initials}</div>
          {!collapsed && (
            <div className="exam-user-info">
              <div className="exam-user-name">{user?.first_name || user?.email || 'User'}</div>
              <div className="exam-user-role">{user?.role || 'Faculty'}</div>
            </div>
          )}
          {!collapsed && <IconLogout />}
        </div>

        {/* Collapse toggle */}
        <button
          className="exam-btn exam-btn-ghost exam-btn-sm"
          style={{ width: '100%', marginTop: 4, justifyContent: collapsed ? 'center' : 'flex-end' }}
          onClick={onToggle}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <IconChevron direction={collapsed ? 'right' : 'left'} />
        </button>
      </div>
    </aside>
  );
}
